"use strict";

import "./List.css";
import React from "react";
import Card from "vwa/components/Card";

const DEFAULT_DISPLAYED_ITEMS = 50;

export default class List extends React.Component {
	
	constructor(props) {
		super(props);
		this.initState();
	}
	
	initState() {
		this.state = {
			displayedItems: this.props.displayedItems
		};
	}
	
	handleScroll() {
		const cont = this.refs.container;
		if (cont.scrollTop >= cont.scrollHeight - cont.clientHeight) {
			this.setState({
				displayedItems: this.state.displayedItems + DEFAULT_DISPLAYED_ITEMS
			});
		}
	}
	
	renderDisplayedItems() {
		if (!this.props.children)
			return null;
		
		if (this.props.children.constructor == Array)
			return this.props.children.filter((_, i) => i < this.state.displayedItems)
		else
			return this.props.children;
	}
	
	render() {
		return (
			<div ref="container" className="List" onScroll={this.handleScroll.bind(this)}>
				{this.renderDisplayedItems()}
			</div>
		);
	}
	
}

List.propTypes = {
	displayedItems: React.PropTypes.number
};

List.defaultProps = {
	displayedItems: DEFAULT_DISPLAYED_ITEMS
};


// WEBPACK FOOTER //
// ./~/vwa/components/List/List.jsx